module.exports = __webpack_public_path__ + "img/messages-bubble.cb549a68.svg";